<app-pageheader [Parent]="this">
  <add-button AddRoute="/enforcement/citations/reasons/new/edit"></add-button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="enforcement/infringement-types/searches"
  [AllowEdit]="true" EditUrl="enforcement/citations/reasons/:id">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview> 
